import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import { HowItWorksSection } from "./components/HowItWorksSection";
import { PlayModesSection } from "./components/PlayModesSection";
import { RankingSection } from "./components/RankingSection";
import { SecuritySection } from "./components/SecuritySection";
import { WhyPlaySection } from "./components/WhyPlaySection";
import { CTASection } from "./components/CTASection";
import { Footer } from "./components/Footer";
import { FloatingActionButton } from "./components/FloatingActionButton";
import { ScrollToTop } from "./components/ScrollToTop";
import { ParticleBackground } from "./components/ParticleBackground";
import { CareersPage } from "./pages/CareersPage";
import { BlogPage } from "./pages/BlogPage";
import { TermsPage } from "./pages/TermsPage";
import { ContactPage } from "./pages/ContactPage";
import { ReportProblemPage } from "./pages/ReportProblemPage";
import { NewsletterPage } from "./pages/NewsletterPage";
import { SuggestionsPage } from "./pages/SuggestionsPage";
import { AboutPage } from "./pages/AboutPage";

function HomePage() {
  return (
    <>
      <Hero />
      <HowItWorksSection />
      <PlayModesSection />
      <RankingSection />
      <SecuritySection />
      <WhyPlaySection />
      <CTASection />
    </>
  );
}

function App() {
  return (
    <div className="App bg-dark-primary relative">
      <ParticleBackground />
      <Header />
      <main className="relative z-10">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/carreiras" element={<CareersPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/termos" element={<TermsPage />} />
          <Route path="/contato" element={<ContactPage />} />
          <Route path="/reportar-problema" element={<ReportProblemPage />} />
          <Route path="/newsletter" element={<NewsletterPage />} />
          <Route path="/sugestoes" element={<SuggestionsPage />} />
          <Route path="/sobre" element={<AboutPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingActionButton />
      <ScrollToTop />
      <Toaster position="top-right" />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
